const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']


function formatHour(hour) {
  const suffix = hour >= 12 ? 'PM' : 'AM'
  const clock = hour % 12 || 12
  return `${clock} ${suffix}`
}


export function formatNextRunEt(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/.exec(value || '')
  if (!match) return null
  const [, , month, day, hour, minute] = match
  const monthLabel = MONTHS[Number(month) - 1]
  if (!monthLabel) return null
  const hourNumber = Number(hour)
  if (hourNumber > 23 || Number(minute) > 59) return null
  const suffix = hourNumber >= 12 ? 'PM' : 'AM'
  return `${monthLabel} ${Number(day)}, ${hourNumber % 12 || 12}:${minute} ${suffix} ET`
}


export function formatScheduleEt(schedule) {
  const weekdays = schedule?.weekday_hours_et
  const weekends = schedule?.weekend_hours_et
  if (!Array.isArray(weekdays) || !weekdays.length || !Array.isArray(weekends) || !weekends.length) {
    return null
  }
  const weekdayStep = weekdays.length > 1 ? weekdays[1] - weekdays[0] : null
  const weekdayText = `Weekdays ${formatHour(weekdays[0])}–${formatHour(weekdays.at(-1))} ET` +
    (weekdayStep ? ` every ${weekdayStep}h` : '')
  const weekendText = weekends.map(formatHour).join(' & ')
  return `${weekdayText} · weekends ${weekendText} ET`
}


export function runtimeStatusText(health) {
  if (!health) return 'Schedule status unavailable'
  if (health.scrape_running) return 'Scrape running'
  if (health.status === 'healthy' && health.healthy !== false) return 'Scraper healthy'
  if (health.status === 'degraded') return 'Scraper degraded'
  if (health.status === 'failed' || health.healthy === false) return 'Scraper needs attention'
  return 'Scraper status unknown'
}


export function runtimeFreshnessClass(health, fallback) {
  if (!health) return fallback
  if (health.scrape_running) return 'recent'
  if (health.status === 'healthy' && health.healthy !== false) return 'fresh'
  if (health.status === 'degraded') return 'aging'
  if (health.status === 'failed' || health.healthy === false) return 'stale'
  return 'unknown'
}


export function runtimeRunTotals(health) {
  const providerCount = health?.providers_expected_count ??
    (Array.isArray(health?.providers_expected) ? health.providers_expected.length : health?.providers_expected)
  if (!health || !Number.isFinite(health.jobs_published) || !Number.isFinite(providerCount)) {
    return null
  }
  const failedNames = [
    ...(health.providers_error || []),
    ...(health.providers_timeout || []),
  ]
  return {
    jobs: health.jobs_published,
    providers: providerCount,
    failed: failedNames.length,
    failedNames,
  }
}
